<div class="seIconText">
  <mat-icon [ngClass]="{'material-icons': !iconOutlined, 'material-icons-outlined': iconOutlined}"
            class="seIconText__icon">
    {{iconName}}
  </mat-icon>

  <span class="seIconText__text" [ngClass]="{'seIconText__text_active': active == true}">{{inputText}}</span>
</div>
